import { JOIN_ROOM, LEAVE_ENTITY } from 'actions';
import {
  SIZE_NODES_BY_OPTIONS,
  VIEW_BY_OPTIONS
} from './constants';
import { FETCH_SMART_FILTER_FAILED } from './containers/SearchFilters/SearchFilters.ducks';
import noop from 'lodash/noop';

const SAVE_TO_GROUP = 'zen/BotIntelligence/AddToGroupModal/SAVE_TO_GROUP';
const SAVE_TO_GROUP_FAILED = 'zen/BotIntelligence/AddToGroupModal/SAVE_TO_GROUP_FAILED';
const SAVE_TO_GROUP_SUCCEEDED = 'zen/BotIntelligence/AddToGroupModal/SAVE_TO_GROUP_SUCCEEDED';
const CLEAR_BANNER_MESSAGE = 'zen/BotIntelligence/Page/CLEAR_BANNER_MESSAGE';
const CLEAR_STATE = 'zen/BotIntelligence/Page/CLEAR_STATE';
const SUBMIT_QUERY = 'zen/BotIntelligence/Page/SUBMIT_QUERY';
const FETCH_SEARCH_RESULTS = 'zen/BotIntelligence/Page/FETCH_SEARCH_RESULTS';
const FETCH_SEARCH_RESULTS_FAILED = 'zen/BotIntelligence/Page/FETCH_SEARCH_RESULTS_FAILED';
const FETCH_SEARCH_RESULTS_SUCCEEDED = 'zen/BotIntelligence/Page/FETCH_SEARCH_RESULTS_SUCCEEDED';
const SELECTED_SIZE_NODES_BY_OPTION_CHANGED = 'zen/BotIntelligence/Page/SELECTED_SIZE_NODES_BY_OPTION_CHANGED';
const SELECT_CLUSTERS = 'zen/BotIntelligence/Page/SELECT_CLUSTERS';
const CLEAR_SELECTION = 'zen/BotIntelligence/Page/CLEAR_SELECTION';
const TOGGLE_VIEW_BY_VALUE = 'zen/BotIntelligence/Page/TOGGLE_VIEW_BY_VALUE';
const SELECTED_VIEW_BY_OPTION_CHANGED = 'zen/BotIntelligence/Page/SELECTED_VIEW_BY_OPTION_CHANGED';
const TOGGLE_SHOW_SELECTION_ONLY = 'zen/BotIntelligence/Page/TOGGLE_SHOW_SELECTION_ONLY';
const TOGGLE_CLUSTER_MENU_BUTTON = 'zen/BotIntelligence/Page/TOGGLE_CLUSTER_MENU_BUTTON';
const TOGGLE_MENU_PANEL = 'zen/BotIntelligence/Page/TOGGLE_MENU_PANEL';
const FILTER_AUTOMATION_SCORE = 'zen/BotIntelligence/Page/FILTER_AUTOMATION_SCORE';
const TOGGLE_UNKNOWN_FILTER = 'zen/BotIntelligence/Page/TOGGLE_UNKNOWN_FILTER';
const TOGGLE_ADD_TO_GROUP_MODAL = 'zen/BotIntelligence/Page/TOGGLE_ADD_TO_GROUP_MODAL';
const SET_GROUP_DESTINATION_FIELDS = 'zen/BotIntelligence/Page/SET_GROUP_DESTINATION_FIELDS';
const SEARCH_DISCOVER = 'zen/BotIntelligence/Page/SEARCH_DISCOVER';
const SET_GRAPH_HOVER = 'zen/BotIntelligence/Page/SET_GRAPH_HOVER';
const SET_GRAPH_HOVER_DATA = 'zen/BotIntelligence/Page/SET_GRAPH_HOVER_DATA';
const UPDATE_AUTHORS = 'zen/BotIntelligence/Page/UPDATE_AUTHORS';
const SOCKET_UPDATE = 'zen/BotIntelligence/Page/SOCKET_UPDATE';
const SET_FILTERED_CLUSTER_NODES = 'zen/BotIntelligence/Page/SET_FILTERED_CLUSTER_NODES';

const initialState = {
  bannerMessage: null,
  isAddToGroupModalOpen: false,
  isClusterMenuButtonOpen: false,
  isLoading: false,
  isMenuPanelOpen: true,
  savedGroup: {},
  authorsById: {},
  selectedSizeNodeByOption: SIZE_NODES_BY_OPTIONS[0],
  selectedTopClustersByVolume: [],
  searchTooltipAuthor: null,
  selectedTooltipAuthor: null,
  groupDestinationFields: [],
  selectedViewByOption: VIEW_BY_OPTIONS.all[4],
  viewBy: 'cluster',
  showSelectionOnly: false,
  filteredAutomationScore: {
    min: 0,
    max: 100,
    isUnknownIncluded: true,
  },
  smartFilterSummaryOnSearch: null,
  lastSearchBy: '',
  // ClusterGraph data
  authorNodes: [],
  clusterLinksByType: {},
  clusterNodesByType: {},
  clusterHoverMapsByType: {},
  filteredClusterNodes:{},
  hoverMap: {},
  onSuccess: noop,
  onError: noop
};

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case TOGGLE_MENU_PANEL:
      return { ...state, isMenuPanelOpen: !state.isMenuPanelOpen };
    case TOGGLE_CLUSTER_MENU_BUTTON:
      return { ...state, isClusterMenuButtonOpen: payload };
    case TOGGLE_VIEW_BY_VALUE: {
      const oldValue = state.viewBy;
      const newValue = (oldValue === 'cluster') ? 'category' : 'cluster';
      return {
        ...state,
        viewBy: newValue,
        selectedViewByOption: initialState.selectedViewByOption,
      };
    }
    case SELECTED_VIEW_BY_OPTION_CHANGED: {
      return {
        ...state,
        selectedViewByOption: payload,
        selectedTopClustersByVolume: [],
        selectedTooltipAuthor: null,
        isClusterMenuButtonOpen: false,
        searchTooltipAuthor: null,
        showSelectionOnly: false
      };
    }
    case SELECTED_SIZE_NODES_BY_OPTION_CHANGED: {
      return { ...state, selectedSizeNodeByOption: payload };
    }
    case SELECT_CLUSTERS: {
      const newState = {
        selectedTopClustersByVolume: payload, selectedTooltipAuthor: null,
        isClusterMenuButtonOpen: false, searchTooltipAuthor: null
      };
      if (payload.length === 0) {
        // deselecting all clusters resets selection only mode
        newState.showSelectionOnly = false;
      }
      return { ...state, ...newState};
    }

    case CLEAR_SELECTION: {
      return {
        ...state,
        showSelectionOnly: false,
        isClusterMenuButtonOpen: false,
        selectedTopClustersByVolume: []
      };
    }
    case TOGGLE_SHOW_SELECTION_ONLY: {
      return { ...state, showSelectionOnly: !state.showSelectionOnly, isClusterMenuButtonOpen: false };
    }

    case SET_FILTERED_CLUSTER_NODES: {
      const newState = {
        filteredClusterNodes: payload
      };
      return { ...state, ...newState};
    }

    case CLEAR_STATE: {
      return initialState;
    }
    case CLEAR_BANNER_MESSAGE: {
      return { ...state, bannerMessage: null };
    }
    case FETCH_SEARCH_RESULTS: {
      return {
        ...state,
        isLoading: true,
        bannerMessage: initialState.bannerMessage,
        clusterNodesByType: initialState.clusterNodesByType,
        selectedTopClustersByVolume: initialState.selectedTopClustersByVolume,
        showSelectionOnly: initialState.showSelectionOnly,
        smartFilterSummaryOnSearch: initialState.smartFilterSummaryOnSearch
      };
    }
    case FETCH_SEARCH_RESULTS_SUCCEEDED: {
      return {
        ...state,
        ...payload,
        isLoading: false,
        selectedViewByOption: initialState.selectedViewByOption
      };
    }
    case FETCH_SEARCH_RESULTS_FAILED: {
      return {...state, bannerMessage: payload, isLoading: false};
    }
    case SAVE_TO_GROUP: {
      return { ...state, bannerMessage: null };
    }
    case SAVE_TO_GROUP_SUCCEEDED: {
      state.onSuccess(payload);
      return { ...state, bannerMessage: payload, isAddToGroupModalOpen: false };
    }
    case SAVE_TO_GROUP_FAILED: {
      state.onError(payload);
      return {...state, bannerMessage: payload, isAddToGroupModalOpen: false };
    }
    case FILTER_AUTOMATION_SCORE: {
      const [min, max] = payload;
      const filteredAutomationScore = {
        ...state.filteredAutomationScore,
        min,
        max
      };
      return {...state, filteredAutomationScore};
    }
    case TOGGLE_UNKNOWN_FILTER: {
      const filteredAutomationScore = {
        ...state.filteredAutomationScore,
        isUnknownIncluded: !state.filteredAutomationScore.isUnknownIncluded
      };
      return {...state, filteredAutomationScore};
    }
    case SET_GROUP_DESTINATION_FIELDS: {
      return {
        ...state,
        groupDestinationFields: payload.groupDestinationFields,
        onSuccess: payload.onSuccess,
        onError: payload.onError,
      };
    }
    case TOGGLE_ADD_TO_GROUP_MODAL: {
      const additionalProps = payload.open
        ? {bannerMessage: null, isClusterMenuButtonOpen: false, hoverMap: {}}
        : {selectedTooltipAuthor: null, searchTooltipAuthor: null};
      return {
        ...state,
        isAddToGroupModalOpen: payload.open,
        selectedTooltipAuthor: payload.selectedTooltipAuthor,
        ...additionalProps
      };
    }
    case SET_GRAPH_HOVER_DATA: {
      return { ...state, hoverMap: payload };
    }
    case SEARCH_DISCOVER: {
      return (payload)
        ? { ...state, searchTooltipAuthor: payload }
        : state;
    }
    case UPDATE_AUTHORS:
      return { ...state, ...payload };
    case FETCH_SMART_FILTER_FAILED:
      return {...state, bannerMessage: payload };
    default:
      return state;
  }
};

const toggleMenuPanelVisibility = () => {
  return { type: TOGGLE_MENU_PANEL };
};

const setClusterMenuButtonVisibility = (payload) => {
  return { type: TOGGLE_CLUSTER_MENU_BUTTON, payload };
};

const toggleViewByOption = () => {
  return { type: TOGGLE_VIEW_BY_VALUE };
};

const setSelectedSizeNodesByOption = (payload) => {
  return { type: SELECTED_SIZE_NODES_BY_OPTION_CHANGED, payload };
};

const setSelectedViewByOption = (payload) => {
  return { type: SELECTED_VIEW_BY_OPTION_CHANGED, payload };
};

const selectClusters = (payload) => {
  return { type: SELECT_CLUSTERS, payload };
};

const clearSelection = () => {
  return { type: CLEAR_SELECTION };
};

const toggleShowSelectionOnly = () => {
  return { type: TOGGLE_SHOW_SELECTION_ONLY };
};

const setfilteredClusterNodes = (payload) => {
  return { type: SET_FILTERED_CLUSTER_NODES, payload };
};

const clearState = () => {
  return { type: CLEAR_STATE };
};

const clearBannerMessage = () => {
  return { type: CLEAR_BANNER_MESSAGE };
};

const submitQuery = (payload) => {
  return { type: SUBMIT_QUERY, payload };
};

const fetchSearchResults = () => {
  return { type: FETCH_SEARCH_RESULTS };
};

const fetchSearchResultsSucceeded = (payload) => {
  return { type: FETCH_SEARCH_RESULTS_SUCCEEDED, payload };
};

const fetchSearchResultsFailed = (payload) => {
  return { type: FETCH_SEARCH_RESULTS_FAILED, payload };
};

const saveToGroup = () => {
  return { type: SAVE_TO_GROUP };
};

const saveToGroupSucceeded = (payload) => {
  return { type: SAVE_TO_GROUP_SUCCEEDED, payload };
};

const saveToGroupFailed = (payload) => {
  return { type: SAVE_TO_GROUP_FAILED, payload };
};

const filterAutomationScore = (payload) => {
  return { type: FILTER_AUTOMATION_SCORE, payload };
};

const toggleUnknownFilter = () => {
  return { type: TOGGLE_UNKNOWN_FILTER };
};

const setGroupDestinationFields = (groupDestinationFields, onSuccess = noop, onError = noop) => {
  const payload = { groupDestinationFields, onSuccess, onError };
  return { type: SET_GROUP_DESTINATION_FIELDS, payload};
};

const setAddToGroupModalVisibility = (open, selectedTooltipAuthor) => {
  const payload = {open, selectedTooltipAuthor};
  return { type: TOGGLE_ADD_TO_GROUP_MODAL, payload};
};

const setGraphHover = (node) => {
  return { type: SET_GRAPH_HOVER, payload: {node, isClusterListHover: false} };
};

const setGraphHoverFromList = (node) => {
  return { type: SET_GRAPH_HOVER, payload: {node, isClusterListHover: true} };
};

const setGraphHoverData = (payload) => {
  return { type: SET_GRAPH_HOVER_DATA, payload };
};

const searchDiscover = (payload) => {
  return { type: SEARCH_DISCOVER, payload };
};

const updateAuthors = (payload) => {
  return { type: UPDATE_AUTHORS, payload };
};
const socketPayload = {room_type: 'bot_intelligence', channel_id: 'bot_detector_authors', options: {}};
// dispatch to saga to take care of socket connection
const joinBotIntelligenceRoom = (foundAuthorIds, missingAuthorIds=[]) => {
  const payload = Object.assign({}, socketPayload, {options: {foundAuthorIds, missingAuthorIds}});
  return { type: JOIN_ROOM, payload };
};
// dispatch to saga to take care of socket disconnection
const leaveBotIntelligenceRoom = () => {
  return { type: LEAVE_ENTITY, payload: socketPayload };
};

export default reducer;
export {
  // Actions
  CLEAR_BANNER_MESSAGE,
  CLEAR_STATE,
  SUBMIT_QUERY,
  FETCH_SEARCH_RESULTS,
  FETCH_SEARCH_RESULTS_FAILED,
  FETCH_SEARCH_RESULTS_SUCCEEDED,
  SAVE_TO_GROUP,
  SAVE_TO_GROUP_SUCCEEDED,
  SAVE_TO_GROUP_FAILED,
  SELECTED_SIZE_NODES_BY_OPTION_CHANGED,
  SELECT_CLUSTERS,
  CLEAR_SELECTION,
  TOGGLE_VIEW_BY_VALUE,
  SELECTED_VIEW_BY_OPTION_CHANGED,
  TOGGLE_SHOW_SELECTION_ONLY,
  SET_FILTERED_CLUSTER_NODES,
  TOGGLE_CLUSTER_MENU_BUTTON,
  TOGGLE_MENU_PANEL,
  FILTER_AUTOMATION_SCORE,
  TOGGLE_UNKNOWN_FILTER,
  TOGGLE_ADD_TO_GROUP_MODAL,
  UPDATE_AUTHORS,
  SOCKET_UPDATE,
  SEARCH_DISCOVER,
  SET_GRAPH_HOVER,
  SET_GRAPH_HOVER_DATA,
  // Action Creators
  clearBannerMessage,
  clearState,
  submitQuery,
  fetchSearchResults,
  fetchSearchResultsFailed,
  fetchSearchResultsSucceeded,
  saveToGroup,
  saveToGroupSucceeded,
  saveToGroupFailed,
  setClusterMenuButtonVisibility,
  toggleMenuPanelVisibility,
  toggleShowSelectionOnly,
  setfilteredClusterNodes,
  setSelectedSizeNodesByOption,
  selectClusters,
  clearSelection,
  setSelectedViewByOption,
  toggleViewByOption,
  setAddToGroupModalVisibility,
  setGroupDestinationFields,
  filterAutomationScore,
  toggleUnknownFilter,
  setGraphHover,
  setGraphHoverFromList,
  setGraphHoverData,
  leaveBotIntelligenceRoom,
  joinBotIntelligenceRoom,
  updateAuthors,
  searchDiscover
};
